import { cn } from "@/lib/utils";

import { MuiListIcon } from "./mui-spec-icons";
import { MuiTypography } from "./mui-typography";

// The donor's `EmptyTable` (`src/components/empty-table/empty-table.tsx:9-19`) —
// **a box, not a table row**: `react-ui`'s `Stack direction='column'
// alignItems='center'` at `py: 15` (120px) on white, the `List` glyph at
// `fontSize: 53`, and the caller's text as an `h4`, with no spacing between the
// two. The details page shows it as "No results" when a search matches no line
// (`SpecDetailsIsland.tsx:239-243`); the Spec list does not use it — its empty
// state is the table's own row (`MuiTableEmptyRow`).
//
// Neither child names a colour, so both inherit the body's `text.primary`
// through MUI's `CssBaseline`. Atlas's body is not that ink, so the box states
// it. A caller's classes land last, as the donor spreads its `sx` last (the
// edit page's `mr: 4`, the item search's `width: 100%; mb: 4`).

export function EmptyTable({ text, className }: { text: string; className?: string }) {
  return (
    <div
      data-slot="empty-table"
      className={cn("text-lennar-ink flex flex-col items-center bg-white py-[120px]", className)}
    >
      <MuiListIcon />
      <MuiTypography variant="h4">{text}</MuiTypography>
    </div>
  );
}
